import StatutoryCompliances from "./StatutoryCompliances";

export default StatutoryCompliances;
export {
    StatutoryCompliances
};